import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow, CCol,
	CForm,CFormInput,CFormSelect,CInputGroup,CInputGroupText,CFormCheck,
		CFormTextarea,CButton,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CBadge,CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 		= require('../../package.json')
const Terapijenis	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 15) : 30;
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uISHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") && !uISDemoapp;
	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 			= uHeaderActionObj.isHeaderTambah || false;

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uIdxRowselected,setIdxRowselected]= React.useState(-1);
	//--END VIEWS_VARS--/

	/*//--PAGING_DIATUR_BACKEND--/
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const [uInitselectedObj,setInitselectedObj] = React.useState({});
	//--PAGING_DIATUR_BACKEND--*/

	//--DLGLOOKUP--/
	//--END DLGLOOKUP--/

	//--DLGFORM--/
	const [uISDlgformshow,setDlgformshow]		= React.useState(false);
	const [uDlgformdataObj,setDlgformdataObj]	= React.useState({});
	//--END DLGFORM--/

	//--DLGVIEW--/
	//--END DLGVIEW--/

	//--DOM_VARS--/
	const uElJmlData			= document.getElementById("idjmldata");
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL 		= parseInt(_IDTABEL)||0; if(_IDTABEL<=0) return;

		const vArridx		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vCaptionupper = ((uDatamainArr[vArridx]||{}).nama_terapi||"").toUpperCase();
		const vIdxRow		= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setIdxRowselected(vIdxRow);

		setDlgformdataObj({
			dlg_header: "Edit Jenis: "+vCaptionupper,
			tabel_id: parseInt(uDatamainArr[vArridx].id)||0,
			nama_terapi: uDatamainArr[vArridx].nama_terapi||"",
			poin_perawat: parseInt(uDatamainArr[vArridx].poin_perawat)||0,
		});
		setDlgformshow(true);
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL 		= parseInt(_IDTABEL)||0; if(_IDTABEL<=0) return;

		const vArridx		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vCaptionupper = ((uDatamainArr[vArridx]||{}).nama_terapi||"").toUpperCase();
		const vIdxRow		= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setIdxRowselected(vIdxRow);

		if(await Konfirm("<p><b>Hapus Jenis '"+vCaptionupper+"'</b>.."+
			"<br/><span class='px-2 fst-italic'>Proses Ini Tidak Dapat Diulang dan Dibatalkan.</span></p>"+
			"<p>Apakah Yakin Akan Dihapus</p>"+
			"")) {
			apiProseshapus(_IDTABEL);
		}
	}
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI--/
		let vElfocus = document.getElementById("inpformnamajenis");
		if((uDlgformdataObj.nama_terapi||"").trim() === "") {
			vElfocus && vElfocus.focus();
			showToast("Nama Jenis Terapi Harus Diisi !"); return;
		}
		if((uDlgformdataObj.nama_terapi||"").trim().length < 3) {
			vElfocus && vElfocus.focus();
			showToast("Nama Jenis Terapi Minimal Harus 3 Karakter !"); return;
		}
		//--END VALIDASI--/

		apiProsessimpan();
	}
	//--END HANDEL--/

	//--INIT_FUNC--/
	//--END INIT_FUNC--/

	//--CONTENT_FUNC--/
	const contentMain = () => {
		if(uHtml500msg) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_terapijenis || "");
		const vKeywordcolor = uSettingObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		//--PAGING_DIATUR_FRONTEND--/
		const vDataviewArr	= uDatamainArr.slice(vMin,vMax);
		//--END PAGING_DIATUR_FRONTEND--*/
		
		/*//--PAGING_DIATUR_BACKEND--/
		const vDataviewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.page||1) === parseInt(uPageActive));
		//--END PAGING_DIATUR_FRONTEND--*/
		
		return (
		<div className="mx-md-5 px-lg-5">
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
				<th width={40} className="px-1"><small>No</small></th>
			
				<th className="px-0">
				<CRow className="mx-0">
					<CCol md="8" className="px-1 text-start"><small>{uBahasaObj.caption_namajenisterapi||"Nama Jenis Terapi"}</small></CCol>
					<CCol md="2" className="px-1"><small>{uBahasaObj.caption_poinperawat||"Poin Perawat"}</small></CCol>
					<CCol md="2" className="px-1">&middot;</CCol>
				</CRow>
				</th>
			</tr>

			<tr className="d-md-none classfontsmaller">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,nama_terapi,poin_perawat,tgl_input,user_input,
			} = vItems;

			vNumber++;
			const vCaptionupper	= (nama_terapi||"").toUpperCase();

			const vNamajenis	= vKeyword==="" ? (nama_terapi||"UNDF NAMA") 
				: (nama_terapi||"UNDF NAMA").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vUserinput	= vKeyword==="" ? UFunc.Usercaptionfilter((user_input||"UNDF User"),1) 
				: UFunc.Usercaptionfilter((user_input||"UNDF User"),1).replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uIdxRowselected===vKeys?" classrowselect":"")}>
				<td className="px-1">{vNumber}.</td>

				<td className="px-1 px-md-0">
				<CRow className="mx-0">
				<CCol md="8" className="px-1 text-md-start d-flex justify-content-between">
					<div className="pe-1">
						<div className="text-info">{UFunc.renderHTML(vNamajenis)}</div>
						<div className="text-danger classfontsmaller d-none d-md-block">
						<small>[
						{UFunc.WaktuAngka(tgl_input)}
						<span> &middot; </span>
						{UFunc.renderHTML(vUserinput)}
						]</small>
						</div>
					</div>

					<CDropdown className="d-md-none">
					<CDropdownToggle caret={false} size="sm" className="p-0" color="transparent">
						<CIcon icon="cilOptions" className="classikonbox" height={25}/>
					</CDropdownToggle>

					<CDropdownMenu>
					<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
						<CIcon className="classikonedit align-middle me-1" height={23}/>
						Edit Data
					</CDropdownItem>

					{uISHapusallow && (
					<>
						<CDropdownDivider/>

						<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
							<CIcon className="classikonhapus align-middle me-1" height={23}/>
							Hapus Data
						</CDropdownItem>
					</>
					)}
					</CDropdownMenu>
					</CDropdown>
				</CCol>

				<CCol xs="12" className="px-1 my-3 classborderbottom d-md-none"/>

				<CCol xs="6" className="px-1 text-start d-md-none">{uBahasaObj.caption_poinperawat||"Poin Perawat"}</CCol>
				<CCol xs="6" md="2" className="px-1 text-md-center">
					{UFunc.formatAngka(poin_perawat)}
					<span className="ms-1 d-md-none">POIN</span>
				</CCol>

				<CCol xs="4" className="px-1 text-start d-md-none classfontsmaller">{uBahasaObj.word_inputby||"Inputby"}</CCol>
				<CCol xs="8" className="px-1 d-md-none text-danger classfontsmaller">
					<small>
						{UFunc.WaktuAngka(tgl_input)}
						<span> &middot; </span>
						{UFunc.renderHTML(vUserinput)}
					</small>
				</CCol>

				<CCol md="2" className="px-1 px-md-0 text-center d-none d-md-block">
					<CLink onClick={()=>hdlKlikEdit(id)} className="classikontabel classikonedit classcursorpointer"/>

					{uISHapusallow && (
					<>
						<small className="d-none d-lg-inline"> &middot; </small>
						<CLink onClick={()=>hdlKlikHapus(id)} className="classikontabel classikonhapus classcursorpointer"/>
					</>
					)}
				</CCol>
				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		</div>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
			<CCol xs="3" md="4">
				<small className="d-md-none">Nama</small>
				<span className="d-none d-md-block">Nama Jenis Terapi</span>
			</CCol>

			<CCol>
				<CFormInput size="sm" maxLength={100}
					value={uDlgformdataObj.nama_terapi||""}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,nama_terapi:e.target.value})}
					id="inpformnamajenis"/>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="4">
				<small className="d-md-none">Poin</small>
				<span className="d-none d-md-block">Poin Perawat</span>
			</CCol>

			<CCol xs="7" md="4" lg="3">
				<CInputGroup size="sm">
				<CFormInput size="sm" type="number"
					className="text-end"
					value={uDlgformdataObj.poin_perawat||"0"}
					onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,poin_perawat:e.target.value})}
					onFocus={(e)=>e.target.select()}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpformpoinperawat"/>
				<CInputGroupText className="fw-bolder">POIN</CInputGroupText>
				</CInputGroup>
			</CCol>
		</CRow>
		</CForm>
		)//>
	}
	//--END CONTENT_FUNC--/

	//--API--/
	const apiLoaddata = () => {
		//_PAGE	= parseInt(_PAGE)||1;//--PAGING_DIATUR_BACKEND--/
		setHtml500msg();

		const vKeyword 		= uKeywordObj.kwd_terapijenis || "";

		//--PAGING_DIATUR_FRONTEND--/
		setDatamainArr([]);
		setIdxRowselected(-1);
		setPageActive(1);
		//--END PAGING_DIATUR_FRONTEND--*/

		/*//--PAGING_DIATUR_BACKEND--/
		let vDatamainArr	= [...uDatamainArr];
		if(vKeyword.length < 3) {
			vDatamainArr 	= []
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) === 1);
			} else
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) !== uPageActive);
		}
		//--END PAGING_DIATUR_BACKEND--*/
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			/*//--PAGING_DIATUR_BACKEND--/
			send_page: _PAGE,
			send_jmlperpage: uMaxData,
			send_loadjml: (JSON.stringify(uLastinitObj||{}) !== "{}") ? "YA" : "TIDAK",
			//--END PAGING_DIATUR_BACKEND--*/
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Terapijenis - apiLoaddata) uPageActive : "+(uPageActive));
				const vTmpArr = JSON.parse(output_string.dataobject||"[]");
				
				//--PAGING_DIATUR_FRONTEND--/
				setDatamainArr([...vTmpArr]);
				//--END PAGING_DIATUR_FRONTEND--*/

				/*//--PAGING_DIATUR_BACKEND--/
				if(vKeyword.length >= 3)
					setJmlData(parseInt(output_string.total_data||uJmlData))
				else setJmlData(vTmpArr.length);

				setDatamainArr([...vDatamainArr,...vTmpArr]);
		    	if(JSON.stringify(uLastinitObj||{}) !== "{}") 
		    		setInitselectedObj(uLastinitObj);
				//--END PAGING_DIATUR_BACKEND--*/

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapijenis - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Terapijenis - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsessimpan = () => {
		const vElsimpan = document.getElementById("btnDialogSimpan");
		vElsimpan && (vElsimpan.disabled=true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_parameter : JSON.stringify({...uDlgformdataObj,
				dlg_header: undefined,
				dlg_size: undefined,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/pr_simpan";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			if(output_string.sukses) {
				const vArridx = UFunc.getObjectIndeks(uDatamainArr,uDlgformdataObj.tabel_id);
				const vTmpObj = {...uDlgformdataObj,
					dlg_header: undefined,
					dlg_size: undefined,
				}
				//console.log("(Terapijenis - apiProseshapus) uPageActive : "+(uPageActive));

				if(vArridx < 0) {
					setDatamainArr([{
						...vTmpObj,
						tgl_input: UFunc.DbDatetime(),
						user_input: uTokenObj.usercaption||"User Input",
						id: parseInt(output_string.tabelnewid)||0,
					},...uDatamainArr]);

					showToast((uBahasaObj.pesan_sukses||"Berhasil !"),"SUKSES");
					setDlgformdataObj({
						...uDlgformdataObj,
						nama_terapi: undefined,
						poin_perawat: undefined,
					});

					if(!isMobile)
						document.getElementById("inpformnamajenis") &&
							document.getElementById("inpformnamajenis").focus();
				} else {
					uDatamainArr[vArridx] = {
						...(uDatamainArr[vArridx]||{}),
						...vTmpObj,
					}

					setDlgformshow(false);
				}
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapijenis - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsimpan && (vElsimpan.disabled = false);
			setLoading(false);
			console.log("(Terapijenis - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		_IDTABEL	= parseInt(_IDTABEL)||0;//--PAGING_DIATUR_BACKEND--/
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				//console.log("(Terapijenis - apiProseshapus) uPageActive : "+(uPageActive));
				const vArridx = UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
				uDatamainArr.splice(vArridx,1);
				setIdxRowselected(-1);
				//setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapijenis - apiProseshapus) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Terapijenis - apiProseshapus) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

    	//const vPageinit	= uPageActive;
		//console.log("(Terapijenis - []) uLastinitObj.initPage => "+(uLastinitObj.initPage))

		//--PAGING_DIATUR_FRONTEND--/
		apiLoaddata();
		//--END PAGING_DIATUR_FRONTEND--*/

		/*//--PAGING_DIATUR_BACKEND--/
		if(JSON.stringify(uLastinitObj||{}) !== "{}") {
			setPageActive(uLastinitObj.initPage||1);
			apiLoaddata(uLastinitObj.initPage||1);
		}
		//--END PAGING_DIATUR_BACKEND--*/

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgformshow(false);
    		setDatamainArr([]); 
			setIdxRowselected(-1); setPageActive(0);
    		//setInitselectedObj({});//->PAGING_DIATUR_BACKEND-/
    	}
	},[]);
	//--PAGING_DIATUR_FRONTEND--/
	React.useEffect(()=>{ 
		setJmlData(uDatamainArr.length);
	},[uDatamainArr.length])
	//--END PAGING_DIATUR_FRONTEND--/
	React.useEffect(()=>{ 
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);

		/*//--PAGING_DIATUR_BACKEND--/
		const vKeyword 		= uKeywordObj.kwd_terapijenis || "";
		if(vKeyword.length < 3) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}
		//--END PAGING_DIATUR_BACKEND--*/
		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uElJmlData,uJmlData]);
	React.useEffect(()=>{ 
		//--PAGING_DIATUR_FRONTEND--/
		setIdxRowselected(-1);
		//--PAGING_DIATUR_FRONTEND--*/

		/*//--PAGING_DIATUR_BACKEND--/
    	if(JSON.stringify(uLastinitObj||{}) !== "{}") return;
    	if(uPageActive <= 0) { setPageActive(1); return }

		setIdxRowselected(-1); 
		const vDataviewArr	= uDatamainArr.filter(vItems=>parseInt(vItems.page||1) === parseInt(uPageActive));
		if(vDataviewArr.length > 0) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}
		apiLoaddata(uPageActive);
		//--END PAGING_DIATUR_BACKEND--*/
	},[uPageActive])
	/*//--PAGING_DIATUR_BACKEND--/
	React.useEffect(()=>{
		if(JSON.stringify(uInitselectedObj||{}) === "{}") return;

		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+(uInitselectedObj.initID||0));
		setIdxRowselected(vIdxRow);

		uDispatch({type: "set", gInitTabelSelected: undefined});
		setInitselectedObj({});
		
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElscroll		= document.getElementById("idtr"+(uInitselectedObj.initID||"0"));
			const vRectdimensi 	= vElscroll && (vElscroll.getBoundingClientRect());
			
			vRectdimensi && (window.scrollTo({ top: (vRectdimensi.top||0) - 150, behavior: "smooth" }))
		},350);
	},[uInitselectedObj])
	//--END PAGING_DIATUR_BACKEND--*/
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		//--PAGING_DIATUR_FRONTEND--/
		apiLoaddata();
		//--END PAGING_DIATUR_FRONTEND--*/

		/*//--PAGING_DIATUR_BACKEND--/
		setDatamainArr([]);
		setJmlData(0);
		setIdxRowselected(-1);

		if(parseInt(uPageActive) !== 1) {
			setPageActive(1);
		} else apiLoaddata();
		//--END PAGING_DIATUR_BACKEND--*/
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		setIdxRowselected(-1);
		if(uHtml500msg) return;

		setDlgformdataObj({
			dlg_header:"Tambah Jenis Terapi Baru",
		});
		setDlgformshow(true);
	},[uHandelTambah])
	React.useEffect(()=>{
		if(!uISDlgformshow)
			{ setDlgformdataObj({}); return }

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElfocus	= document.getElementById("inpformnamajenis");

			if(!isMobile)
				vElfocus && vElfocus.focus();
		},300)
	},[uISDlgformshow])

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<b>{uBahasaObj.caption_page500||"Page 500"}</b>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)//>

	return (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-center">
			<div>
				<b className="align-middle">{uBahasaObj.caption_listdata||"List Data"}</b>
				<span className="mx-1 d-md-none">&middot;</span>
				<small className="d-md-none text-primary align-middle">{(()=>{
					/*//--PAGING_DIATUR_BACKEND--/
					const vKeyword = (uKeywordObj.kwd_terapijenis||"").trim();
					if(vKeyword.length < 3) return (<>&#8734;</>);
					//--END PAGING_DIATUR_BACKEND--*/

					return (<>[{UFunc.formatAngka(uJmlData)}]</>)
				})()}</small>
			</div>

			<span className="text-muted classfontsmaller">
				<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
			</span>
			<small className="d-none">({uJmlData} - {uMaxData})</small>
		</CCardHeader>
		
		<CCardBody className="px-0 px-md-3">{contentMain()}</CCardBody>

		{(uJmlData > uMaxData) && (
		<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/> 
		</CCardFooter>
		)}
		</CCard>

		<MyDialogform
			options={{size:(uDlgformdataObj.dlg_size||"lg"),centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformdataObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Terapijenis